import React from "react";
import { BConnectedButton } from "./BConnectedButton";
import { BDrivePopover } from "./Popovers/BDrivePopover";

export function BDriveButton() {
  return (
    <BConnectedButton service="Drive">
      <BDrivePopover />
    </BConnectedButton>
  );
}
